<template>
    <div class="p-discount-rate-update">
        <h2>
            Claims Preview
        </h2>

        <div class="o-filter-options__box flex-grid flex-grid--reduced-bottom-margin a-form-inputs flex-grid--wrap">
            <div class="flex-grid__g-3" >
                <discount-rate-options></discount-rate-options>
            </div>
            <div class="flex-grid__g-1">
                <modal-in-the-wild modal-name="discount-rate-warning" v-if="discountRatesOptions">
                    <button class="a-button a-button--small u-no-margin" v-if="claimsToBeUpdatedTotal > 1">
                        Apply
                    </button>
                </modal-in-the-wild>
                <button class="a-button a-button--small u-no-margin" v-if="claimsToBeUpdatedTotal < 1" disabled>
                    Apply
                </button>
            </div>
        </div>

        <div class="o-content ie p-your-claims u-no-padding">
            <div class="p-your-claims__table-container">
                <table class="a-table a-table--full-width your-claims-table p-your-claims__table">
                    <thead>
                    <tr>
                        <th>
                            <div>
                                <div class="a-checkbox p-discount-rate-update__select-all-checkbox">
                                    <input type="checkbox" id="all" checked @change="selectAll">
                                    <label for=""></label>
                                </div>
                            </div>
                        </th>
                        <th>
                            <a href="#">
                                Your Reference
                            </a>
                        </th>
                        <th>
                            <a href="#">
                                Claim Type
                            </a>
                        </th>
                        <th>
                            <a href="#">
                                Claimant Name
                            </a>
                        </th>
                        <th>
                            <a href="#">
                                Defendant Name
                            </a>
                        </th>
                        <th>
                            <a href="#">
                                Current Discount Rate
                            </a>
                        </th>
                        <th>
                            <a href="#">
                                Current Value
                            </a>
                        </th>
                        <th>
                            <a href="#">
                                Value at New Current Discount Rate ({{discountRates[updateDiscountRate]}})
                            </a>
                        </th>
                        <th>
                            <a href="#">
                                Difference
                            </a>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(claim, index) in preview.data">
                        <td>
                            <div class="a-checkbox u-margin-top-10">
                                <input type="checkbox" id="claimId" :value="claim.id" :checked="claim.selected" @click="updateSelected(claim.id)">
                                <label for=""></label>
                            </div>
                        </td>
                        <td>
                            {{ claim.yourReference }}
                        </td>
                        <td>
                            {{ claim.humanClaimType }}
                        </td>
                        <td>
                            {{ claim.claimantName }}
                        </td>
                        <td>
                            {{ claim.defendantName }}
                        </td>
                        <td>
                            {{ claim.discountRate }}%
                        </td>
                        <td>
                            {{ currencyFormat(claim.headsOfLossTotal) }}
                        </td>
                        <td>
                            {{ currencyFormat(claim.headsOfLossPreview) }}
                        </td>
                        <td>
                            {{ currencyFormat(showDifference(claim.headsOfLossTotal, claim.headsOfLossPreview)) }}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!--<ul class="m-pagination">-->
            <!--<li v-for="page in pageNumbers" class="m-pagination__item"-->
                <!--:class="[ page == isActive ? 'm-pagination__item&#45;&#45;active' : '']">-->
                <!--<a href="#" @click.prevent="changePage(page)">-->
                    <!--{{ page }}-->
                <!--</a>-->
            <!--</li>-->
        <!--</ul>-->

        <div class="p-discount-rate-update__total u-margin-top-20">
            <h3>Total Difference For All Claims</h3>
            {{ currencyFormat(totalDifference()) }}
        </div>

        <div class="u-d-flex u-flex-center flex-grid--column p-discount-rate-comparison__pie-container u-margin-top-50">
            <h3>Comparison Between Discount Rates</h3>
            <pie :labels="['Current Discount Rate', 'New Discount Rate']" :dataset="dataset()" :total="totalDifference()" totalText="Total Difference"></pie>
        </div>
        <div class="u-text-center">
            <chart-legend
                    :values="[
                        'Current Discount Rate',
                        'New Discount Rate'
                    ]"
                    :legendWidth="chartLegendWidth"
                    marginTop="30"
                    marginBottom="30">
            </chart-legend>
        </div>

        <modal name="discount-rate-warning" no-default-button="true">
            <h2>Warning</h2>
            You are about the change the discount rate to {{ discountRates[updateDiscountRate] }} on {{ claimsToBeUpdatedTotal }} claim(s).<br/><br/>
            This process can take several minutes <br/><br/>
            In this time you will not be able to use this feature or update the discount rate until this process has finished. <br/><br/>
            <button class="a-button a-button--small u-no-margin" @click="close">Cancel</button>
            <button class="a-button a-button--small u-no-margin" @click="startUpdateDiscountRate">Apply</button>
        </modal>
    </div>
</template>

<script>
    import _ from 'lodash';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import AccordionItem from 'components/accordion/AccordionItem.vue';
    import currencyFormat from 'mixins/currencyFormat';
    import percentageDifference from 'mixins/percentageDifference';
    import roundValue from 'mixins/roundValue';
    import BarChart from 'components/graphs/HorizontalBarChart';
    import HeadOfLossRow from 'pages/discount-rate-comparison/components/tables/HeadOfLossRow.vue';
    import OptionFilters from 'components/OptionFilters.vue';
    import ChartLegend from 'components/chart/Legend.vue';
    import DiscountRateOptions from 'pages/discount-rate-comparison/components/form/DiscountRateOptions.vue';
    import Modal from 'components/modal/Modal.vue';
    import ModalContent from 'components/modal/ModalContent.vue';
    import ModalInTheWild from 'components/modal/ModalInTheWild.vue';
    import Pie from 'pages/discount-rate-comparison/components/charts/Pie';

    export default {
        name: 'Claims-Preview',
        components: {
            AccordionItem,
            HeadOfLossRow,
            BarChart,
            OptionFilters,
            ChartLegend,
            DiscountRateOptions,
            Modal,
            ModalContent,
            ModalInTheWild,
            Pie,
        },
        mixins: [
            currencyFormat,
            roundValue,
            percentageDifference,
        ],
        data() {
            return {
                tableType: "average",
                offset: 4
            }
        },
        computed: {
            ...mapState('discountRateComparison', [
                'preview',
                'discountRates',
                'updateDiscountRate',
                'discountRatesOptions',
            ]),
            ...mapGetters('discountRateComparison', [
                'averageHeadsOfLossGraph',
                'averageHeadsOfLossTable',
                'totalHeadsOfLossGraph',
                'totalHeadsOfLossTable',
                'claimsToBeUpdatedTotal'
            ]),
            ...mapGetters('windowWidth', ['theCurrentWidth']),
            isActive: function () {
                return this.preview.currentPage;
            },
            pageNumbers: function () {
                if (!this.preview.to) {
                    return [];
                }
                let from = this.preview.currentPage - this.offset;
                if (from < 1) {
                    from = 1;
                }
                let to = from + (this.offset * 2);
                if (to >= this.preview.lastPage) {
                    to = this.preview.lastPage;
                }
                let pagesArray = [];
                while (from <= to) {
                    pagesArray.push(from);
                    from++;
                }
                return pagesArray;
            },
            chartLegendWidth() {
                switch (true) {
                    case this.theCurrentWidth <= 700:
                        return 100;
                        break;
                    case this.theCurrentWidth <= 900:
                        return 90;
                        break;
                    case this.theCurrentWidth <= 1024:
                        return 70;
                        break;
                    default:
                        return 80;
                }
            }
        },
        methods: {
            ...mapActions('modal', ['toggle']),
            ...mapActions('discountRateComparison', ['apply', 'updateClaimSelect', 'loadPreview']),
            changePage(page) {
                this.preview.currentPage = page;
                this.loadPreview();
            },
            showDifference(val1, val2) {
                if (val1 > val2) {
                    return val1 - val2;
                }
                return val2 - val1;
            },
            updateSelected(claimId) {
                this.updateClaimSelect(claimId);
            },
            close() {
                this.toggle('discount-rate-warning');
            },
            startUpdateDiscountRate() {
                this.toggle('discount-rate-warning');
                this.apply();
            },
            headsOfLossTotal() {
                return this.preview.data.reduce(function (total, claim) {
                    return total + claim.headsOfLossTotal;
                }, 0);
            },
            headsOfLossPreview() {
                return this.preview.data.reduce(function (total, claim) {
                    return total + claim.headsOfLossPreview;
                }, 0);
            },
            totalDifference() {
                return this.headsOfLossTotal() - this.headsOfLossPreview();
            },
            dataset(rate) {
                return [{
                    data: [this.headsOfLossTotal(), this.headsOfLossPreview()],
                    backgroundColor: ["#45BFFC", "#3DF2C3"],
                    borderWidth: 0,
                }];
            },
            selectAll() {
                this.preview.data.forEach(function (claim) {
                    this.updateSelected(claim.id)
                }, this);
            }
        },
    }
</script>



// WEBPACK FOOTER //
// ClaimsPreview.vue?f95d7c4a